import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import AccountItems from './AccountItems';

const useStyles = buildUseStyles('TabContent', (() => ({
  root: {},
})));

const TabContent = ({ resource }) => {
  const classes = useStyles();
  return (
    <Box
      className={classes.root}
    >
      <AccountItems collection={resource?.attr('nextUpAccountItems')} />
    </Box>
  );
};

TabContent.defaultProps = {
};

TabContent.propTypes = {
  resource: PropTypes.object.isRequired,
};


export default TabContent;
